import styles from './ProductLabelProperty.module.scss'
import React from 'react'

type Props = {
  label: string,
  value?: string | number | undefined,
  icon?: React.FunctionComponent<any>,
}

const ProductLabelProperty = (props: Props) => {
  const IconComponent = props.icon as React.ElementType

  return (
    <div className={styles.component}>
      {props.value && (
        <div className={styles.value}>{props.value}</div>
      )}
      {props.icon && (
        <IconComponent
          className={styles.icon}
        />
      )}
      <div className={styles.label}>{props.label}</div>
    </div>
  )
}

export default ProductLabelProperty